module.exports = __webpack_public_path__ + "static/media/graph.f765958c.svg";